/*
 *
 * Audiences constants
 *
 */

export const FLUSH_STATE_AUDIENSES = 'app/Audiences/FLUSH_STATE_AUDIENSES';

// LOAD
export const LOAD_AUDIENSES = 'app/Audiences/LOAD_AUDIENSES';
export const LOAD_AUDIENSES_SUCCESS = 'app/Audiences/LOAD_AUDIENSES_SUCCESS';
export const LOAD_AUDIENSES_ERROR = 'app/Audiences/LOAD_AUDIENSES_ERROR';